import { css } from 'emotion';
import { animationTransition } from '@joykit/variables';
import { getInterUIDynamicMetricCssObject } from 'fonts/Inter-UI/metrics';

export namespace styles {
  export const container = css({});
  export const filterOption = css({
    flex: 0,
    flexGrow: 1,
    cursor: 'pointer',
    padding: '16px 24px 16px 0',
    borderBottom: '1px solid #EBEBEB',
    backgroundColor: 'white',
    transition: animationTransition('background-color'),
    overflow: 'hidden',
    ':not(:last-child)': {
      '@media(min-width: 678px)': {
        borderRight: '1px solid #EBEBEB'
      }
    },
    '@media(min-width: 678px)': {
      padding: '16px 24px'
    }
  });

  export const valueContainer = css({
    minHeight: 20,
    color: '#888888',
    ...getInterUIDynamicMetricCssObject(14),
    maxWidth: '80%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  });

  export const resetContainer = css({
    height: '32px',
    display: 'flex',
    width: '100%',
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '16px',
    ...getInterUIDynamicMetricCssObject(14)
  });
}
